export const TRANSACTIONS_START = 'transactions/TRANSACTIONS_START';
export const TRANSACTIONS_SUCCESS = 'transactions/TRANSACTIONS_SUCCESS';
export const TRANSACTIONS_ERROR = 'transactions/TRANSACTIONS_ERROR';

export const TRANSACTIONS_MORE_START = 'transactions/TRANSACTIONS_MORE_START';
export const TRANSACTIONS_MORE_SUCCESS = 'transactions/TRANSACTIONS_MORE_SUCCESS';

export const TRANSACTIONS_REFRESH_START = 'transactions/TRANSACTIONS_REFRESH_START';
